import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
      { path: '/', name: 'homePage', component: require(page+'home.vue').default },
	    { path: '/registro', name: 'registerPage', component: require(page+'register.vue').default, meta:{title:"Registro"}},

      { path: '/aviso-de-privacidad', component: require(page+'text-pages/aviso.vue').default, meta:{ title:"Aviso de privacidad" } },
      { path: '/politicas-de-contratacion', component: require(page+'text-pages/politicas.vue').default, meta:{ title:"Políticas de contratación" } },

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "Marquez Express Inc.", filter: (title)=>{ return title+" - Marquez Express Inc."; } }
);

// export {routes};
export default MyRouter;
